<template>
  <component
    :is="mapType[type]"
    v-bind="componentProps"
    :disabled="disabled"
  />
</template>

<script>

import _get from 'lodash/get'
import EventBus from '@/eventBus'
import _ from 'lodash'

export default {
  name: 'BlockEditor',
  components: {
    RichTextBlock: () => import('./RichTextBlock.vue'),
    ImageBlock: () => import('./ImageBlock.vue'),
    EmojiBlock: () => import('./EmojiBlock.vue'),
    LineBlock: () => import('./LineBlock.vue'),
    ShapeBlock: () => import('./ShapeBlock.vue'),
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    componentData: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mapType: {
        RichText: 'RichTextBlock',
        Image: 'ImageBlock',
        Emoji: 'EmojiBlock',
        Shape: 'ShapeBlock',
        Line: 'LineBlock',
      },
    }
  },
  computed: {
    componentProps() {
      let transformData = { }
      const transformDataFunc = this[`transformDataType${this.type}`]
      if (transformDataFunc) {
        transformData = transformDataFunc()
      }
      return {
        ...transformData,
        blockStyle: {
          width: _get(this.componentData, 'style.width'),
          height: _get(this.componentData, 'style.height'),
          transform: _get(this.componentData, 'style.transform'),
        },
        blockContent: _get(this.componentData, 'content'),
        blockId: this.componentData.id,
        slideId: this.componentData.slideId,
        preview: this.preview,
        animation: _.get(this.componentData, 'content.animation'),
        isInfinity: _.get(this.componentData, 'content.isInfinity'),
        duration: _.get(this.componentData, 'content.duration'),
      }
    },
  },
  methods: {
    transformDataTypeRichText() {
      return {
        value: _get(this.componentData, 'content.value'),
      }
    },
    transformDataTypeImage() {
      return _get(this.componentData, 'content')
    },
    transformDataTypeEmoji() {
      return _get(this.componentData, 'content')
    },
    transformDataTypeShape() {
      return _get(this.componentData, 'content')
    },
    onRichTextEditorUpdate(textUpdate) {
      this.$emit('update-content', {
        value: textUpdate,
      })
    },
    onRichTextEditorInitBlur() {
      EventBus.$emit('inputInitBlurComplete', this.componentData.id)
    },
    ready(slideId) {
      this.$emit('ready', slideId)
    },
  },
}
</script>

<style scoped>

</style>
